import { memo } from 'react';

import { ComponentContextProps } from '@/components';
import { Logo, LogoProps } from '@/components/core';
import { WebhookIcon } from '@/components/icons';

export type WebhookLogoProps = LogoProps & Partial<ComponentContextProps>;

const IWebhookLogo = ({ variant, className, ...rest }: WebhookLogoProps) => {
  return (
    <Logo variant={variant} className={className} {...rest}>
      <WebhookIcon />
    </Logo>
  );
};

export const WebhookLogo = memo(IWebhookLogo) as typeof IWebhookLogo;
